export default "__VITE_ASSET__DVDRCCuV__"